import React from 'react'
;

const Brand = () => {

    

    return (
        <div className="brand-area">
            <div className="container">
                <div className="rc-carousel" data-loop="true" data-items={4} data-margin={30} data-autoplay="true" data-autoplay-timeout={5000} data-smart-speed={2000} data-dots="false" data-nav="false" data-nav-speed="false" data-r-x-small={2} data-r-x-small-nav="false" data-r-x-small-dots="false" data-r-x-medium={3} data-r-x-medium-nav="false" data-r-x-medium-dots="false" data-r-small={4} data-r-small-nav="false" data-r-small-dots="false" data-r-medium={4} data-r-medium-nav="false" data-r-medium-dots="false" data-r-large={4} data-r-large-nav="false" data-r-large-dots="false">
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand1.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand2.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand3.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand4.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand5.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand6.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand7.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand8.png" alt="brand" /></a>
                    </div>
                    <div className="brand-area-box">
                        <a href="#"><img src="/images/brand9.png" alt="brand" /></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export  {Brand};